export const WEBSHOP_FETCH_EVENTS_START =   'WEBSHOP_FETCH_EVENTS_START';
export const WEBSHOP_FETCH_EVENTS_SUCCESS = 'WEBSHOP_FETCH_EVENTS_SUCCESS';
export const WEBSHOP_FETCH_EVENTS_FAILURE = 'WEBSHOP_FETCH_EVENTS_FAILURE';

export const WEBSHOP_SELECT_EVENT = 'WEBSHOP_SELECT_EVENT';